import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
    backgroundColor: '#3f9673',
    color: '#ffffff',
    textAlign: 'center',
    fontWeight: 'bold'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(-1),
    color: '#ffffff'
  }
});

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: 5
  },
  typography: {
    padding: theme.spacing(1)
  },
  linkButton: {
    color: '#ffffff',
    backgroundColor: '#ffb914',
    padding: theme.spacing(2),
    fontWeight: 'bold',
    margin: theme.spacing(3, 0, 3, 0),
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: '#d49500'
    }
  }
}));

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h5">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    textAlign: 'center'
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    justifyContent: 'space-between'
  }
}))(MuiDialogActions);

export default function ShareReferralForWeb(props) {
  const classes = useStyles();
  const { isOpen, isClose, user } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openClipboardToolTip, setOpen] = React.useState(false);

  function handleClick() {
    navigator.clipboard.writeText(
      `https://chessify.me/signin?ref=${user.userCode}`
    );
    setOpen(true);
  }

  const handleCloseModal = () => {
    isClose();
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        onClose={handleCloseModal}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleCloseModal}>
          Earn with Chessify!
        </DialogTitle>
        <DialogContent dividers>
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
              PopperProps={{
                disablePortal: true
              }}
              open={openClipboardToolTip}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              onMouseLeave={handleTooltipClose}
              placement="top"
              title="Copied to clipboard"
              arrow
            >
              <Button
                className={classes.linkButton}
                autoFocus
                onClick={handleClick}
                color="worning"
                variant="contained"
              >
                Copy Referral Link
              </Button>
            </Tooltip>
          </ClickAwayListener>
        </DialogContent>
        <DialogActions>
          <div style={{ padding: '20px' }}>
            <Typography gutterBottom>
              Your Earnings: <b>${user.referral_balance}</b>
            </Typography>
            <Typography gutterBottom>
              Referred Users: <b>{user.referred_users_count}</b>
            </Typography>
          </div>
          <div style={{ padding: '20px' }}>
            <img
              height="50px"
              src={
                navigator.userAgent.toLowerCase().indexOf('safari') !== -1 &&
                  navigator.userAgent.toLowerCase().indexOf('chrome') <= -1
                  ? '/dg_static/website/images/chessify_icon.jpg'
                  : '/dg_static/website/images/chessify_icon.webp'
              }
              alt="Chessify"
            />
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
